import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class ApprovedSubjects extends Api {
  constructor(http, config = {}) {
    super(http, url, 'students', config);
  }

  findByStudentRegister (record = null, idCareer= null, idStudyPlan=null, config = {}) {
    config = {...this._config, ...config};
    const uri = `${url}/students/${record}/equivalentsSubjects?idCareer=${idCareer}&idStudyPlan=${idStudyPlan}`
    
    return this._http.get(uri, config);
  }
}
